import { gql } from "@outschool/ui-apollo";

export const THREAD_DETAIL_QUERY = gql`
  query ThreadDetail($threadUid: ID!) {
    thread(threadUid: $threadUid) {
      uid
      classPost {
        uid
        title
      }
      learningAssignmentClassPost {
        uid
        title
      }
      messages {
        uid
        sender {
          uid
          name
          photo
          isLearner
        }
        messageContent {
          uid
          text
          attachments {
            uid
            fileUrl
            file {
              filename
              mimetype
              size
              url
              thumbUrl
            }
            conversionStatus
            created_at
          }
          video {
            uid
            fileUrl
            file {
              filename
              mimetype
              size
              url
              thumbUrl
            }
            conversionStatus
            created_at
          }
        }
        sentAt
      }
    }
  }
`;
